/**
 * Created by roi on 2/05/17.
 */
import { ESTACIO_SELECCIONADA, OBSERVACIO_INICIALITZAR } from '../../../actions/actionTypes.js';

const ESTAT_INICIAL_ESTACIO_SELECCIONADA = null;

const codiSeleccionada = (state = ESTAT_INICIAL_ESTACIO_SELECCIONADA, action) => {
    switch (action.type) {
        case ESTACIO_SELECCIONADA:
            return action.codiEstacio;
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_ESTACIO_SELECCIONADA;
        default:
            return state;
    }
};

export default codiSeleccionada;



// WEBPACK FOOTER //
// ./src/reducers/observacio/estacio/codiSeleccionada.js